import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../../Global/loader.js'
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-modal';
import { Button, Row, Col } from 'react-bootstrap'
import Create from './CreateNaciniPlacanja.js'
import GetMeansOfPayment from '../../../../API/Provider/GetMeansOfPayment'
import { withNamespaces } from 'react-i18next';
import Select from 'react-select'
import GetCountries from '../../../../API/Provider/GetProviderCountries'
import { RiDeleteBin5Line } from 'react-icons/ri'
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import Edit from './UpdateNaciniPlacanja'
import { store } from 'react-notifications-component';
import DeleteMeansOfPayment from '../../../../API/Provider/DeleteMeansOfPayment'
import CreateButton from './../../../../Global/CreateButton'
import history from '../../../../history.js';

class NaciniPlacanja extends React.Component {
    constructor(props) {
        super(props)
        
        this.state={
            loading: true,
            create: false,
            showDeleteModal: false,     
            uuidForDelete: "",  
            edit: false,
            customStyles: {
                content : {
                    top                   : '50%',
                    left                  : '50%',
                    right                 : 'auto',
                    bottom                : 'auto',
                    transform             : 'translate(-50%, -50%)',
                    color: 'red'
                }
            }
        }
    }

    componentDidMount = async () => {        
        document.title = this.props.t("Means of payment") + "-" + this.props.t("List")
        
        this.setState({loading: true})   
        
        //get countries
        let items = await GetCountries(this.props)       
        let countryList = []
        
        await items.data.countries
            .map((data, index) =>{
            let oneItem = {value: data.uuid , label: data.country_name }
            countryList.push(oneItem)
            return null
        })

        if(this.props.searchCountry !== null){
            let data = countryList.filter((data) => data.value === this.props.searchCountry)
            .map((data) => {return data})

            await this.props.mapState("CODEBOOK_CHANGE_SEARCH_MEANS_OF_PAYMENT_PARAMETERS", data[0])
            await this.setState({
                countries: countryList,
                country: data[0]
            })
            await this.search()
        }
        else{
            await this.props.mapState("CODEBOOK_CHANGE_SEARCH_MEANS_OF_PAYMENT_PARAMETERS", countryList[0])
            await this.setState({
                countries: countryList,
                country: countryList[0]
            })
            await this.search()
        }
         /* 
        await this.setState({
            loading: false            
        })
        */
    }

    toggleCreate = async () => {
        this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
    }

    backFromEdit(){
        this.setState({
            edit: !this.state.edit
        })
        this.componentDidMount()
    }


    showDeleteModal = data => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: data.uuid,
            countrUuidForDelete: data.country_uuid
        });
    };

    confirmDelete = async () => {
        const { t } = this.props

        let deleteItem = await DeleteMeansOfPayment(this.state.uuidForDelete, this.state.countrUuidForDelete)   
        if(deleteItem.data.status !== 200){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })     
            await store.addNotification({
                title: this.props.t('Error!'),
                message: t(deleteItem.data.message),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            }) 

            await store.addNotification({
                title: this.props.t('Success!'),
                message: t("Payment method deleted."),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.componentDidMount()
        }
    }

    seeDetails = async (data) => {
        await this.props.mapState("MAP_ONE_MEANS_OF_PAYMENT", data)
        await this.setState({
            edit: !this.state.edit
        })
    }

    handleCountryChange = async (e) => {
        await this.setState({
            country: e
        })
        let data = {
            value: this.state.country.value
        }
        await this.props.mapState("CODEBOOK_CHANGE_SEARCH_MEANS_OF_PAYMENT_PARAMETERS", data)

        await this.search()
    }

    backFromEdit = async () =>{
        await this.setState({
            edit: !this.state.edit
        })

        this.componentDidMount()
    }

    goBack(){
        history.goBack();
    }

    search = async () => {
        await this.setState({ loading: true})

        let lista = await GetMeansOfPayment(this.props.searchCountry)

        if(lista.data.length > 0){
            await this.props.mapState("MAP_MEANS_OF_PAYMENT_LIST", lista.data)
        }
        else{
            this.props.mapState("MAP_MEANS_OF_PAYMENT_LIST", [])
        }

        await this.setState({ loading: false })
    }
   
    render(){  
        const { loading, create, edit } = this.state 
        const { t } = this.props

        const columns =[{
            dataField: 'description',
            text: t('Description'),
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"},
        }, {
            dataField: 'fiscalization_label',
            text: t('Fiscalization Form.Label'),
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"},  
        }, {
            dataField: 'country_name',
            text: t('Country Name'),
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"}, 
        },/* {
            dataField: 'allowed_invoice_type',
            text: t('Allowed Invoice Types'),
            style: {wordWrap: "break-word"}           
        },*/ {
            dataField: 'fiscalize',
            text: t('Fiscalize'),
            style: {wordWrap: "break-word"},
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid} className={`${row.fiscalize ? "color-green" : "color-red"}`}>
                        <strong>
                            { row.fiscalize ?  t("Yes") : t("No") }
                        </strong>
                    </div>
                );
            }                
        }, {
            dataField: 'send_receipt',
            text: t('Create receipt'),
            style: {wordWrap: "break-word"},
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid} className={`${row.send_receipt ? "color-green" : "color-red"}`}>
                        <strong>
                            { row.send_receipt ?  t("Yes") : t("No") }
                        </strong>
                    </div>
                );
            }         
        }, {
            dataField: 'sakriveno',
            isDummyField: true,
            text: '',
            style:{  width: '6em' },
            formatter: (cellContent, row) => {          
            return (
                <div key={row.uuid}>
                    <div 
                        className="btn btn-danger btnIzbrisi"
                        id={row.uuid}
                        onClick={() => this.showDeleteModal(row)}
                    >
                        <RiDeleteBin5Line /> {t('Delete')} 
                    </div> 
                
                </div>
                
            );
            }
        }] 

    return (
        loading ? 
            <Loader />
        :
            
        create ? 
            <Create goBack={() => this.backFromCreate()} />
        :
        edit ? 
            <Edit goBack={() => this.backFromEdit()} />
        :
        <div className="container">
            <Row>               
                <Col sm="8" xl="4" className="p-4" >
                    {this.state.countries.length > 0 ?       
                        <Select
                            options={this.state.countries} 
                            onChange={(values) => this.handleCountryChange(values)}
                            isInvalid={this.state.country === null}
                            value={this.state.country}        
                            maxMenuHeight={200}                                    
                        /> 
                    : null}
                </Col>
               
                <div className="col-4 col-xl-8">      
                    <CreateButton style={{padding:"20px"}} className="col-6 col-xl-4" toggleCreate={this.toggleCreate}/>
                </div>

            </Row>                     
                {this.props.meansOfPaymentList.length > 0 ?
                    <ToolkitProvider
                        keyField="uuid"
                        data={this.props.meansOfPaymentList}
                        columns={columns}
                        columnToggle
                        prikaziSakrij = {this.prikaziSakrij}
                        bodyStyle={ {wordBreak: 'break-word'} }
                    >
                        {(props) => (
                        <div className="table-responsive">
                            <BootstrapTable {...props.baseProps} hover bodyClasses="table-body" />
                        </div>
                        )}
                    </ToolkitProvider>  
                : 
                <div className="list-empty-container">
                    <h1>{t(this.props.message)}</h1>
                </div>
            }

            <Modal
                isOpen={this.state.showDeleteModal}                
                onRequestClose={() => this.showDeleteModal("")}
                style={this.state.customStyles}
            >

                <h3 className="modal-title">{t('Warning!')}</h3>
                        
                <div className="mb-4">
                    <p>
                        {t('Deleting the Means of payment will also delete other data related to it.')}       
                    </p>                     
                </div>

                <Row>
                    <Col sm={6}>
                        <Button variant="primary" onClick={() => this.showDeleteModal("")}>{t('Close')}</Button>
                    </Col>
                    <Col sm={6}>
                        <Button variant="danger" onClick={() => this.confirmDelete()}> {t('Delete')}</Button>
                    </Col>                
                </Row>                    
            </Modal> 
        </div>
    )
}
}
const mapStateToProps = state => {
    return {
        oneMeansOfPayment: state.adminClient.oneMeansOfPayment,
        meansOfPaymentList: state.codeBook.meansOfPaymentList,
        message: state.adminClient.message,
        credentials: state.user.credentials,

        pageSize: state.codeBook.Country.pageSize,
        activePage: state.codeBook.Country.activePage,
        sortBy: state.codeBook.Country.sortBy,
        activeOnly: state.codeBook.Country.activeOnly,
        sortDirection: state.codeBook.Country.sortDirection,
        search: state.codeBook.Country.search,

        searchCountry: state.codeBook.MeansOfPayment.search.countryUuid
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(NaciniPlacanja));